module.exports = __webpack_public_path__ + "img/MDI-message-question.47ff5527.svg";